module.exports = __webpack_public_path__ + "img/eletromidia.abdb3794.svg";